export default function (key: string): number[] {
  const matchAll = key?.matchAll(/\d+/g);

  return [...matchAll]?.map((e) => Number(e[0])) ?? [];
}
